import { Icon } from 'prensa'
import React from 'react'

const RightArrowIcon = (props) => {
  return (
    <Icon color='black' width='18px' height='18px' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M9 3 7.94 4.06l4.19 4.19H3v1.5h9.13l-4.19 4.19L9 15l6-6z' />
    </Icon>
  )
}

export { RightArrowIcon }